import { Group, Anchor } from '@mantine/core'
import { 
  IconHome, 
  IconSettings,
  IconFileText,
  IconCalendarEvent
} from '@tabler/icons-react'
import { navbarStyles } from './Navbar.styles';
import { useCurrentPage } from '@/hooks/useCurrentPage';

export function Navbar() {
  const { currentPath } = useCurrentPage();
  
  const links = [
    { link: '/', label: 'Главная', icon: <IconHome /> },
    { link: '/services', label: 'Услуги', icon: <IconSettings /> },
    { link: '/documents', label: 'Документы', icon: <IconFileText /> },
    { link: '/booking', label: 'Запись', icon: <IconCalendarEvent /> },
  ];
  
  return (
    <div style={navbarStyles.bar as any}>


    <Group gap={15} style={navbarStyles.links as any} justify='center'> 
      {links.map((link) => (
        <Anchor 
          key={link.label} 
          href={link.link} 
          c={currentPath === link.link ? 'var(--mantine-color-white)' : 'var(--mantine-color-gray-6)'}
        > 
          {link.label}
        </Anchor>
      ))}
    </Group>
    </div>
  )
}